// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadRealTimePrices,
} from "@insite/client-framework/Store/Pages/StaticList/Handlers/LoadWishListIfNeeded";
import { getSettingsCollection } from "@vanmeter/App/Store/Selectors/SettingsSelectors";
import { parseBoolean } from "@vanmeter/XDL/Utilities";

// XNG-Changes: skip pricing if !showPricingAvailability
const XngLoadRealTimePrices: typeof LoadRealTimePrices = async props => {
    const settings = getSettingsCollection(props.getState());
    const showPricingAvailability = parseBoolean(settings?.customSettings?.showPricingAvailability);
    if (!showPricingAvailability) {
        props.pricingLoaded = true;
        return;
    }

    return LoadRealTimePrices(props);
};

replaceInChain(chain, LoadRealTimePrices, XngLoadRealTimePrices);
